import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { addToSelected, resetDialog, openDialog } from '../modules/tableDialog'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { changeTabState,
  deleteUserFromGroup,
  fetchUserProfile,
  patchUserGroups } from '../modules/user'
import { resetForm, showDialog, setConfirmationItem } from '../modules/formDialog'
import FormDialog from '../components/formDialog'
import { getUserName } from '../utils/helpers'
import Messages from '../constants/messages'
import { paginationChangePage, paginationChangeRowsPerPage } from '../modules/table'
import { push } from 'react-router-redux'
import TableDialog from '../components/tableDialog'
import TabDisplay from '../components/tabDisplay'
import TableDisplay from '../components/tableDisplay'
import UserProfile from '../components/userProfile'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  classes: PropTypes.object.isRequired,
  userProfile: PropTypes.object
}

const styles = theme => ({
  root: {
    maxWidth: 1000,
    margin: 'auto'
  },
  title: theme.title
})

export class User extends Component {

  tabOptions = [
    Messages['uiComponents']['TAB_PROFILE'],
    Messages['uiComponents']['TAB_GROUPS']
  ]

  userTableButtons = [
    {
      buttonName: 'Clear',
      callback: (item) => {
        this.props.showDialog(true, 'clear')
        this.props.setConfirmationItem(item)
      },
      tooltip: `${Messages['tooltips']['REMOVE']} from`
    }
  ]

  userGroupsTableOptions = [
    {
      name: 'name',
      friendlyName: Messages['uiComponents']['TABLE_NAME_COLUMN'],
      displayType: 'link',
      callback: (group) => this.props.changePage({pathname: `/groups/${group.id}`, state: group})
    },
    {
      name: 'description',
      friendlyName: Messages['uiComponents']['TABLE_DESCRIPTION_COLUMN'],
      displayType: 'string'
    }
  ]

  componentDidMount() {
    const { fetchUserProfile, userProfile, userList } = this.props
    const id = process.env.NODE_ENV === 'test' ? 1 : decodeURI(window.location.pathname).substring(decodeURI(window.location.pathname).lastIndexOf('/') + 1)
    if (userProfile !== null && (!userProfile.user || userProfile.user.id !== id)) {
      if (userList.length > 0) {
        fetchUserProfile(id)
      }
    }
  }

  dialogOptions = {
    clear: [
      {
        type: 'confirmation',
        name:'name',
        friendlyName: Messages['uiComponents']['GROUP_REMOVE_USER_INPUT_FIELD'],
        confirmationType: 'removeFromGroup'
      }
    ]
  }

  handleOnChange(index) {
    const { changeTabState } = this.props
    changeTabState(index)
  }

  handleSubmit(values) {
    const {
      confirmationItem,
      userProfile,
      deleteUserFromGroup,
      resetForm } = this.props
    deleteUserFromGroup(confirmationItem.id, userProfile.user.id)
    resetForm()
  }

  renderDialog() {
    const {
      addToSelected,
      groups,
      isLoadingDialog,
      openDialog,
      resetDialog,
      patchUserGroups,
      selected,
      showTableDialog,
      tabState,
      userProfile } = this.props
      if (tabState === 1) { //only want the button to show when on the table view
        return (
          <TableDialog
            addToSelected={addToSelected}
            buttonLabel={Messages['uiComponents']['ADD_USER_TO_GROUP_TITLE']}
            resetDialog={resetDialog}
            data={groups}
            userData={userProfile.groups}
            handleSubmit={() => {
              selected.length > 0 ? patchUserGroups(userProfile.user.id, selected) : resetDialog()
            }}
            infoText={Messages['uiComponents']['ADDING_USER_MSG']}
            isLoading={isLoadingDialog}
            selected={selected}
            showDialog={showTableDialog}
            title={Messages['uiComponents']['ADD_USER_TO_GROUP_TITLE']}
            openDialog={openDialog} />
        )
      }
  }

  render() {
    const {
      authProfile,
      classes,
      confirmationItem,
      currentContext,
      formType,
      open,
      paginationChangePage,
      paginationChangeRowsPerPage,
      paginationPage,
      paginationRowsPerPage,
      isLoadingDialog,
      userProfile,
      resetForm,
      showDialog,
      tabState } = this.props

    return (
      <section className={classes.root}>
        <h3 className={classes.title}>{currentContext}</h3>
        { userProfile && this.renderDialog() }
        <FormDialog
          dialogOptions={this.dialogOptions[formType] || []}
          handleFormSubmit={() => this.handleSubmit()}
          infoText={Messages['uiComponents']['REMOVING_MSG']}
          isLoading={isLoadingDialog}
          open={open}
          confirmationItem={confirmationItem}
          confirmationFieldData={{userName: getUserName(userProfile), groupName: confirmationItem && confirmationItem.name }}
          showDialog={showDialog}
          resetFormValues={resetForm}
          title={`${Messages['uiComponents']['REMOVE']} From Group`} />
        <TabDisplay
          onChange={(event, tabIndex) => this.handleOnChange(tabIndex)}
          tabState={tabState}
          tabOptions={this.tabOptions} />
        { tabState === 0 &&
          <section>
            <UserProfile initialValues={userProfile && userProfile.user ? userProfile.user : {}}/>
          </section>
        }
        { tabState === 1 &&
          <section>
            <TableDisplay
              authProfile={authProfile}
              data={userProfile && userProfile.groups ? userProfile.groups : []}
              page={paginationPage}
              paginationChangePage={paginationChangePage}
              paginationChangeRowsPerPage={paginationChangeRowsPerPage}
              rowsPerPage={paginationRowsPerPage}
              tab="group"
              tableOptions={this.userGroupsTableOptions}
              tableButtons={this.userTableButtons}
              totalCount={userProfile && userProfile.groups ? userProfile.groups.length : 0}
              type="userGroups" />
          </section>
        }
      </section>
    )
  }
}

User.propTypes = PROP_TYPES

const mapStateToProps = state => ({
  authProfile: state.authProfile,
  confirmationItem: state.formDialog.confirmationItem,
  currentContext: state.navigation.currentContext,
  groups: state.group.groups,
  paginationPage: state.table.paginationPage.userGroups,
  paginationRowsPerPage: state.table.paginationRowsPerPage.userGroups,
  roles: state.role.roles,
  selected: state.tableDialog.selected,
  showTableDialog: state.tableDialog.showTableDialog,
  tabState: state.user.tabState,
  userGroups:state.user.userGroups,
  userProfile: state.user.userProfile,
  userList: state.user.users,
  userRoles: state.user.userRoles,
  open: state.formDialog.open,
  isLoadingDialog: state.loading.isLoadingDialog,
  formType: state.formDialog.formType
})

const mapDispatchToProps = dispatch => bindActionCreators({
  addToSelected,
  changePage: (pushObj) => push(pushObj),
  changeTabState,
  deleteUserFromGroup,
  resetDialog,
  fetchUserProfile,
  setConfirmationItem,
  openDialog,
  paginationChangePage,
  paginationChangeRowsPerPage,
  patchUserGroups,
  resetForm,
  showDialog
}, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(User)
